import React, { Component, useEffect, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import Form from "../comman/form";
import config from "../config.json";
import Swal from "sweetalert2";
import SignaturePad from "react-signature-canvas";
import Moment from "react-moment";
import auth from "../services/authService";
import UploadDocument from "../comman/UploadDocument";
import Joi from "joi-browser";
import publicIp from "react-public-ip"
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useState } from "react";
import { getCurrentUser } from "../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import { formatPhoneNumber, getFieldData } from "../services/appService";
import {
  addNewPurchaseOrder, getPOAddedStatus, getPoOrderDocSasUrl,
  getPOUploadedStatus, purchaseOrderUploaded, uploadNewPurchaseOrder
} from "../app/store/purchaseOrder";
import { uploadFileToBlob } from "../services/blobUploadService";

const cssStyles = `
  #printBody {
    font-family: Arial, Helvetica, sans-serif;
    color: #182033;
    line-height: 1.5;
    background-color: #ffffff;
    font-size: 13px;
  }

  .po-document-shell {
    border: 0;
    background-color: #ffffff;
  }

  .po-document-accent {
    width: 100%;
    border-collapse: collapse;
  }

  .po-document-accent td {
    height: 8px;
    line-height: 8px;
    font-size: 1px;
  }
  
  .po-header-table {
    width: 100%;
    border-collapse: collapse;
    border-bottom: 1px solid #d8e1ee;
    background-color: #f7f9fc;
  }
  
  .po-header-text {
    text-align: center;
    font-size: 11px;
    color: #5f6d83;
    padding: 12px 18px 14px 18px;
  }
  
  .po-header-text p {
    margin: 2px 0;
  }
  
  .po-header-text a {
    color: #2563eb;
    text-decoration: none;
  }
  
  .po-title-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #ffffff;
  }
  
  .po-main-title {
    font-size: 25px;
    font-weight: 800;
    color: #111827;
    text-transform: uppercase;
    margin: 0;
    letter-spacing: 0.04em;
  }

  .po-title-label {
    color: #0f766e;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: 4px;
    line-height: 1.2;
  }
  
  .po-subtitle-relation {
    font-size: 12.5px;
    color: #4b5870;
    margin: 5px 0 0 0;
  }
  
  .po-subtitle-relation span {
    text-transform: uppercase;
    font-weight: 700;
    color: #0f766e;
  }
  
  .po-meta-label {
    font-size: 9.5px;
    font-weight: 700;
    text-transform: uppercase;
    color: #66738a;
    letter-spacing: 0.05em;
    margin-bottom: 2px;
    line-height: 1.2;
  }
  
  .po-meta-value {
    font-size: 13.5px;
    font-weight: 700;
    color: #111827;
  }

  .po-meta-card {
    border: 1px solid #d8e1ee;
    background-color: #f8fafc;
  }

  .po-meta-cell {
    width: 50%;
    padding: 10px 12px;
    vertical-align: middle;
  }

  .po-meta-cell.left {
    border-right: 1px solid #d8e1ee;
  }
  
  .po-parties-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .po-party-card {
    vertical-align: top;
    background-color: #fbfcff;
    border: 1px solid #d8e1ee;
    padding: 14px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  
  .po-party-card.issued-by {
    border-left: 4px solid #0f766e;
  }
  
  .po-party-card.issued-to {
    border-left: 4px solid #2563eb;
  }
  
  .po-party-label {
    font-size: 9px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #66738a;
    margin-bottom: 6px;
    line-height: 1.2;
  }
  
  .po-party-name {
    font-size: 14px;
    font-weight: 700;
    color: #111827;
    margin-bottom: 4px;
    line-height: 1.25;
  }
  
  .po-party-address {
    font-size: 11.5px;
    color: #4b5870;
    line-height: 1.4;
    margin-bottom: 4px;
  }
  
  .po-party-contact {
    font-size: 11px;
    color: #66738a;
  }
  
  .po-party-contact a {
    color: #2563eb;
    text-decoration: none;
  }

  .po-party-box {
    width: 100%;
    height: 140px;
    border-collapse: collapse;
    border: 1px solid #d8e1ee;
    background-color: #f9fbff;
  }

  .po-party-accent {
    width: 4px;
    height: 140px;
    padding: 0;
    font-size: 1px;
  }

  .po-party-content {
    height: 140px;
    padding: 14px 18px;
    vertical-align: top;
  }
  
  .po-section-title-container {
    background-color: #ffffff;
  }

  .po-section-heading-cell {
    padding: 9px 12px 8px 14px;
    background-color: #fbfcff;
    border-left: 4px solid #f59e0b;
    border-right: 1px solid #d8e1ee;
    border-top: 1px solid #d8e1ee;
    border-bottom: 1px solid #d8e1ee;
  }
  
  .po-section-main-title {
    font-size: 14px;
    font-weight: 700;
    color: #111827;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    line-height: 1.25;
  }
  
  .po-section-subtitle {
    font-size: 11.5px;
    color: #66738a;
    margin: 3px 0 0 0;
  }
  
  .po-details-table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #d8e1ee;
    background-color: #ffffff;
  }
  
  .po-details-label {
    width: 31%;
    background-color: #f4f7fb;
    color: #445066;
    font-weight: 700;
    font-size: 11.5px;
    padding: 9px 14px;
    border-right: 1px solid #d8e1ee;
    border-bottom: 1px solid #d8e1ee;
    letter-spacing: 0.01em;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  
  .po-details-value {
    color: #182033;
    font-size: 12px;
    font-weight: 500;
    padding: 9px 16px;
    border-bottom: 1px solid #d8e1ee;
  }
  
  .po-details-table tr:last-child .po-details-label,
  .po-details-table tr:last-child .po-details-value {
    border-bottom: none;
  }
  
  .po-details-table tr:nth-child(even) .po-details-value {
    background-color: #fbfcff;
  }

  .po-rate-value {
    background-color: #eefbf7;
    color: #0f766e;
    font-size: 13px;
    font-weight: 700;
  }

  .po-detail-strong {
    color: #111827;
    font-weight: 700;
  }

  .po-terms-note {
    background-color: #f8fafc;
    border: 1px solid #d8e1ee;
    color: #5f6d83;
    font-size: 11.5px;
    font-style: italic;
    line-height: 1.5;
    padding: 11px 15px;
    text-align: center;
  }
  
  .po-signatures-block {
    width: 100%;
    border-collapse: collapse;
  }
  
  .po-sig-column {
    width: 50%;
    vertical-align: top;
  }
  
  .po-sig-column.left {
    padding-right: 15px;
  }
  
  .po-sig-column.right {
    padding-left: 15px;
  }
  
  .po-sig-company {
    font-size: 12.5px;
    font-weight: 700;
    color: #111827;
    margin-bottom: 12px;
    min-height: 32px;
  }
  
  .po-sig-placeholder {
    border-top: 1.5px solid #cbd5e1;
    padding-top: 6px;
  }
  
  .po-sig-label {
    font-size: 9.5px;
    font-weight: 700;
    text-transform: uppercase;
    color: #94a3b8;
    margin-bottom: 2px;
    letter-spacing: 0.05em;
  }
  
  .po-sig-name {
    font-size: 12px;
    font-weight: 600;
    color: #1e293b;
  }
  
  .po-sig-title {
    font-size: 11px;
    color: #64748b;
  }
  
  .po-esign-watermark {
    display: inline-block;
    border: 1px solid #a7f3d0;
    background-color: #ecfdf5;
    color: #047857;
    padding: 6px 12px;
    border-radius: 4px;
    font-family: Courier, monospace;
    font-size: 10.5px;
    font-weight: bold;
    line-height: 1.3;
    margin-bottom: 12px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
`;

const PrintPurchaseOrder = (props) => {
  const {
    genShowHide,
    handleGenShowHide,
    candidateObj,
    workflowTask,
    poAction,
    allPoTypes,
  } = props;

  const [ipAddress, setIpAddress] = useState("");
  const [esignName, setEsignName] = useState("");
  const [poType, setPoType] = useState("");
  const [otherNotes, setOtherNotes] = useState("");
  const [poId, setPoId] = useState(0);
  const [partnerName, setPartnerName] = useState("");
  const [partAddress, setPartAddress] = useState("");
  const [partContact, setPartContact] = useState("");
  const [partEmail, setPartEmail] = useState("");
  const [payRate, setPayRate] = useState(0);
  const [strDate, setStrDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [keyName, setKeyName] = useState("");
  const [partTitle, setPartTitle] = useState("Key Contact");
  const [ssn, setSsn] = useState("");
  const [documents, setDocuments] = useState([]);
  const [pdfBtnProccess, setPdfBtnProccess] = useState(false);
  const [saveBtnProccess, setSaveBtnProccess] = useState(false);
  const [updBtnProccess, setUpdBtnProccess] = useState(false);
  const [receiverPoType, setReceiverPoType] = useState("New");

  const pOAddedStatusSelector = useSelector(getPOAddedStatus);
  const pOUploadedStatusSelector = useSelector(getPOUploadedStatus);
  const poOrderDocSasUrlSelector = useSelector(getPoOrderDocSasUrl);

  const printBodyRef = useRef();
  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!genShowHide) {
      setEsignName("");
      setPoType("");
      setOtherNotes("");
      setDocuments([]);
      setSsn("");
      setPoId(0);
    }
  }, [genShowHide])

  useEffect(() => {
    const loadIpAddress = async () => {
      const ipv4 = await publicIp.v4() || "127.0.0.0";
      setIpAddress(ipv4);
    }
    loadIpAddress();
  }, []);

  useEffect(() => {
    if (candidateObj && poType) {
      if (candidateObj?.duration) {
        setStrDate(new Date(candidateObj.duration?.startDate)?.toLocaleDateString());
        setEndDate(new Date(candidateObj.duration?.endDate)?.toLocaleDateString());
      }
      let ddName = "";
      if (poType === "subcontractor") {
        ddName = "subcontractorenrollmentform";
        setPoId(candidateObj.subcontractor?.fuid);
        setPayRate(candidateObj.rates?.subcontractorRate)
      }
      if (poType === "recruiter") {
        ddName = "recruiterenrollmentform";
        setPoId(candidateObj.recruiter?.fuid);
        setPayRate(candidateObj.rates?.recruiterRate)
      }

      if (poType === "recruiter" || poType === "subcontractor") {
        setKeyName(getKeyName(candidateObj.performerData, ddName));
        setPartnerName(getFieldData(candidateObj.performerData, ddName, "Company_Name"))
        setPartTitle(getFieldData(candidateObj.performerData, ddName, "Key_Contact1_Title"));
        setPartContact(getFieldData(candidateObj.performerData, ddName, "Company_Phone"));
        setPartEmail(getFieldData(candidateObj.performerData, ddName, "Company_Email"));
        setPartAddress(getPartnerAddress(candidateObj.performerData, ddName));
      }

      if (poType === "candidate") {
        ddName = "candidateonboardingform";
        setPoId(candidateObj.performerid);
        setPayRate(candidateObj.rates?.candidateRate);
        const candName = candidateObj.performername + " " + candidateObj.lastName;
        setPartnerName(candName);
        setKeyName(candName);
        setPartTitle("Candidate");
        setPartContact(getFieldData(candidateObj.performerData, ddName, "Mobile_No"));
        setPartEmail(getFieldData(candidateObj.performerData, ddName, "Email"));
        setPartAddress(getCandidateAddress(candidateObj.performerData, ddName));
      }

      let sn = getFieldData(candidateObj.performerData, "candidateonboardingform", "Social_Security_No");
      if (sn !== "") sn = sn.substring(sn.length - 4);
      setSsn(sn);
    }
  }, [candidateObj, poType]);

  const uploadPoOrder = () => {
    setUpdBtnProccess(true);
    let subconId = 0;
    let recId = 0;
    if (poType === "subcontractor")
      subconId = candidateObj.subcontractor.fuid;
    if (poType === "recruiter") recId = candidateObj.recruiter.fuid;
    const poObject = {
      type: poType,
      candidateId: candidateObj.performerid,
      subcontractorId: subconId,
      recruiterId: recId,
      ipcsSignBy: currentUser.id,
      ciid: workflowTask.ciid,
      notes: otherNotes,
    };
    const frmData = new FormData();
    frmData.append("purchaseOrder", JSON.stringify(poObject));
    frmData.append("files", JSON.stringify(documents.map((file) => {
      return {
        name: file.name,
        type: file.type,
        size: file.size
      }
    })));

    dispatch(uploadNewPurchaseOrder(frmData));
  };

  useEffect(() => {
    const uploadAllDocuments = async () => {
      if (poOrderDocSasUrlSelector?.length > 0) {
        try {
          await Promise.all(
            documents.map((file, key) =>
              uploadFileToBlob(
                file.file,
                poOrderDocSasUrlSelector[key]?.uploadUrl,
                (progress) => {
                  console.log(`Upload progress: ${progress}%`);
                }
              )
            )
          );

          console.log("All files uploaded successfully!");
          dispatch(purchaseOrderUploaded({ sasUrls: null, status: false }));
          setDocuments([]);
        } catch (error) {
          console.error("Upload failed:", error);
        }
      }
    };

    uploadAllDocuments();
  }, [poOrderDocSasUrlSelector]);

  useEffect(() => {
    if (pOUploadedStatusSelector) {
      setUpdBtnProccess(false);
      handleGenShowHide("save", "");
    }
  }, [pOUploadedStatusSelector])

  const doSubmit = async () => {
    setSaveBtnProccess(true);
    try {
      let subconId = 0;
      let recId = 0;
      if (poType === "subcontractor")
        subconId = candidateObj.subcontractor.fuid;
      if (poType === "recruiter") recId = candidateObj.recruiter.fuid;

      const poObject = {
        type: poType,
        candidateId: candidateObj.performerid,
        subcontractorId: subconId,
        recruiterId: recId,
        ipcsSignBy: currentUser.id,
        ciid: workflowTask.ciid,
        notes: otherNotes,
        ipcsSignerName: esignName,
        ipcsIpAddress: ipAddress,
      };
      const pdfBlob = await generatePurchaseOrderPdfBlob();
      const pdfFileName = `Purchase_Order_${poId || candidateObj.performerid || "New"}.pdf`;
      const frmData = new FormData();
      frmData.append("purchaseOrder", JSON.stringify(poObject));
      frmData.append("useClientGeneratedPdf", "true");
      frmData.append("file", pdfBlob, pdfFileName);
      dispatch(addNewPurchaseOrder(frmData));
    } catch (error) {
      console.error("Unable to save generated purchase order PDF", error);
      setSaveBtnProccess(false);
      Swal.fire("Save failed", "Unable to generate the Purchase Order PDF for saving.", "error");
    }
  };

  useEffect(() => {
    if (pOAddedStatusSelector) {
      setSaveBtnProccess(false);
      handleGenShowHide("save", "");
    }
  }, [pOAddedStatusSelector])

  const handlePrintPdf = async () => {
    setPdfBtnProccess(true);
    try {
      const pdfBlob = await generatePurchaseOrderPdfBlob();
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, "_blank");
    } catch (error) {
      console.error("Unable to generate purchase order PDF", error);
      Swal.fire("PDF generation failed", "Unable to generate the Purchase Order PDF in the browser.", "error");
    } finally {
      setPdfBtnProccess(false);
    }
  };

  const generatePurchaseOrderPdfBlob = async () => {
    const printElement = printBodyRef.current?.closest(".po-document-shell");
    if (!printElement) throw new Error("Purchase order preview was not found.");

    const canvas = await html2canvas(printElement, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
      logging: false,
    });

    const pdf = new jsPDF("p", "pt", "a4");
    const margin = 24;
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const availableWidth = pageWidth - margin * 2;
    const availableHeight = pageHeight - margin * 2;
    const widthScale = availableWidth / canvas.width;
    const heightScale = availableHeight / canvas.height;
    const imageScale = Math.min(widthScale, heightScale);
    const imgWidth = canvas.width * imageScale;
    const imgHeight = canvas.height * imageScale;
    const xPosition = (pageWidth - imgWidth) / 2;
    const yPosition = (pageHeight - imgHeight) / 2;
    const imgData = canvas.toDataURL("image/png");

    pdf.addImage(imgData, "PNG", xPosition, yPosition, imgWidth, imgHeight);

    return pdf.output("blob");
  };

  const getPartnerAddress = (data, type) => {
    const add1 = getFieldData(data, type, "Company_Address_Line1");
    const add2 = getFieldData(data, type, "Company_Address_Line2");
    const state = getFieldData(data, type, "Company_State");
    const city = getFieldData(data, type, "Company_City");
    const zip = getFieldData(data, type, "Company_Zip_Code");
    let partAddress = "";
    if (add1 !== "") partAddress += add1 + ", ";
    if (add2 !== "") partAddress += add2 + ", ";
    if (state !== "") partAddress += state + ", ";
    if (city !== "") partAddress += city + ", ";
    if (zip !== "") partAddress += zip;

    return partAddress;
  };

  const getCandidateAddress = (data, type) => {
    const add1 = getFieldData(data, type, "Current_Address_Line1");
    const add2 = getFieldData(data, type, "Current_Address_Line2");
    const state = getFieldData(data, type, "Current_State");
    const city = getFieldData(data, type, "Current_City");
    const zip = getFieldData(data, type, "Current_Zip_Code");
    let partAddress = "";
    if (add1 !== "") partAddress += add1 + ", ";
    if (add2 !== "") partAddress += add2 + ", ";
    if (state !== "") partAddress += state + ", ";
    if (city !== "") partAddress += city + ", ";
    if (zip !== "") partAddress += zip;

    return partAddress;
  };

  const getKeyName = (data, type) => {
    const first = getFieldData(data, type, "Key_Contact1_First_Name");
    const middle = getFieldData(data, type, "Key_Contact1_Middle_Name");
    const last = getFieldData(data, type, "Key_Contact1_Last_Name");
    const name = first + " " + middle + " " + last;
    return name;
  };

  const onFileChange = (event) => {
    const docs = [];
    for (const file of event.target.files) {
      var doc = {
        name: file.name,
        type: file.type,
        file: file,
        size: file.size,
      };
      docs.push(doc);
    }
    setDocuments(docs);
  };

  const handleFileRemove = (item) => {
    const index = documents.indexOf(item);
    let docs = [...documents];
    if (index !== -1) {
      docs.splice(index, 1);
      setDocuments(docs);
    }
  };

  return (
    <Modal
      show={genShowHide}
      size="xl"
      centered
      scrollable
      dialogClassName="rt-tools-modal theme-primary"
      onHide={() => handleGenShowHide("")}
    >
      <Modal.Header style={{ borderBottom: "1px solid #edf2f7" }}>
        <div className="rt-header-shell">
          <div className="rt-header-top">
            <div className="rt-header-main">
              <div className="rt-header-icon">
                <i className="fa fa-file-text-o" />
              </div>
              <div className="rt-header-copy">
                <h1 className="rt-modal-title">
                  <span className="rt-modal-title-text">
                    {poAction === "generate" ? "Add Purchase Order" : "Upload Purchase Order"}
                  </span>
                </h1>
                <div className="rt-modal-meta-row">
                  <span className="rt-meta-chip">
                    <i className="fa fa-user" /> {candidateObj?.performername || "Candidate"} {candidateObj?.lastName || ""}
                  </span>
                  <span className="rt-meta-chip">
                    <i className="fa fa-id-badge" /> ID: {candidateObj?.performerid || "N/A"}
                  </span>
                  <span className="rt-meta-desc">
                    <i className="fa fa-info-circle" /> {poAction === "generate" ? "Generate a styled commercial purchase order for performer engagement." : "Upload scanned or executed purchase order document."}
                  </span>
                </div>
              </div>
            </div>
            <button
              type="button"
              className="rt-action-btn"
              onClick={() => handleGenShowHide("")}
              title="Close popup"
            >
              <i className="fa fa-times" />
            </button>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body className="px-4 py-4" style={{ backgroundColor: "#f8fafc" }}>
        <style>{`
          /* Custom Backdrop and Modal Layout mirroring ToolsPopup */
          .modal-backdrop {
            z-index: 1080 !important;
          }
          .modal {
            z-index: 1090 !important;
          }
          .modal-backdrop.show {
            backdrop-filter: blur(8px) !important;
            -webkit-backdrop-filter: blur(8px) !important;
            background-color: rgba(15, 23, 42, 0.45) !important;
            opacity: 1 !important;
          }
          .modal.fade .rt-tools-modal.modal-dialog {
            transform: scale(0.95) !important;
            transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
          }
          .modal.show .rt-tools-modal.modal-dialog {
            transform: scale(1) !important;
          }
          .rt-tools-modal {
            --task-accent: #2563eb;
            --task-soft: #eff6ff;
            max-width: 90% !important;
            width: 1200px !important;
          }
          .rt-tools-modal.modal-dialog-centered.modal-dialog-scrollable {
            height: auto !important;
          }
          .rt-tools-modal .modal-content {
            border-radius: 12px !important;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
            overflow: hidden !important;
            background: #ffffff !important;
            max-height: calc(100vh - 60px) !important;
            height: auto !important;
            display: flex !important;
            flex-direction: column !important;
          }
          .rt-tools-modal .modal-header {
            position: relative !important;
            display: block !important;
            padding: 24px 28px 20px 32px !important;
            background: linear-gradient(90deg, var(--task-soft) 0%, rgba(255,255,255,0.98) 54%, #ffffff 100%) !important;
            border-bottom: 1px solid #edf2f7 !important;
            overflow: hidden !important;
          }
          .rt-tools-modal .modal-header::before {
            content: "" !important;
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            bottom: 0 !important;
            width: 4px !important;
            background: var(--task-accent) !important;
          }
          .rt-tools-modal .rt-header-shell {
            display: flex !important;
            flex-direction: column !important;
            gap: 14px !important;
            width: 100% !important;
          }
          .rt-tools-modal .rt-header-top {
            display: flex !important;
            justify-content: space-between !important;
            align-items: flex-start !important;
            gap: 18px !important;
            width: 100% !important;
          }
          .rt-tools-modal .rt-header-main {
            display: flex !important;
            align-items: center !important;
            gap: 14px !important;
            min-width: 0 !important;
            flex: 1 1 auto !important;
          }
          .rt-tools-modal .rt-header-copy {
            display: flex !important;
            flex-direction: column !important;
            gap: 8px !important;
            min-width: 0 !important;
            padding-top: 4px !important;
          }
          .rt-tools-modal .rt-modal-title {
            display: inline-flex !important;
            align-items: center !important;
            margin: 0 !important;
            color: #0f172a !important;
            font-size: 18px !important;
            font-weight: 850 !important;
            line-height: 1.2 !important;
            min-width: 0 !important;
          }
          .rt-tools-modal .rt-header-icon {
            width: 52px !important;
            height: 52px !important;
            min-height: 52px !important;
            border-radius: 10px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            color: var(--task-accent) !important;
            background: #ffffff !important;
            border: 1px solid var(--task-accent) !important;
            box-shadow: 0 8px 18px -12px rgba(15,23,42,0.28) !important;
            font-size: 15px !important;
            flex-shrink: 0 !important;
          }
          .rt-tools-modal .rt-modal-title-text {
            display: inline-flex !important;
            align-items: center !important;
            gap: 12px !important;
            min-width: 0 !important;
            flex-wrap: wrap !important;
          }
          .rt-modal-meta-row {
            display: flex !important;
            align-items: center !important;
            flex-wrap: wrap !important;
            gap: 10px 12px !important;
            margin-top: 0 !important;
            padding-left: 0 !important;
            font-size: 12px !important;
            color: #64748b !important;
          }
          .rt-meta-chip {
            display: inline-flex !important;
            align-items: center !important;
            gap: 6px !important;
            background: #ffffff !important;
            padding: 5px 10px !important;
            border-radius: 8px !important;
            font-weight: 700 !important;
            color: #475569 !important;
            border: 1px solid #e2e8f0 !important;
            box-shadow: 0 1px 3px rgba(15,23,42,0.04) !important;
          }
          .rt-meta-chip i {
            color: var(--task-accent) !important;
            font-size: 11px !important;
          }
          .rt-meta-desc {
            display: inline-flex !important;
            align-items: center !important;
            gap: 6px !important;
            color: #64748b !important;
            font-weight: 500 !important;
            line-height: 1.4 !important;
          }
          .rt-meta-desc i {
            color: var(--task-accent) !important;
          }
          .rt-tools-modal .modal-body {
            padding: 24px !important;
            background: #f8fafc !important;
            max-height: calc(100vh - 180px) !important;
            overflow-y: auto !important;
          }
          .rt-tools-modal .rt-action-btn {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            width: 40px !important;
            height: 40px !important;
            padding: 0 !important;
            font-size: 12px !important;
            font-weight: 700 !important;
            color: #64748b !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 8px !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
            outline: none !important;
          }
          .rt-tools-modal .rt-action-btn:hover {
            color: #0f172a !important;
            border-color: #94a3b8 !important;
            background: #f8fafc !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
          }
          .rt-tools-modal .rt-action-btn:hover i {
            color: #ef4444 !important;
          }
          .rt-tools-modal .modal-footer {
            background: #f8fafc !important;
            border-top: 1px solid #edf2f7 !important;
            padding: 16px 24px !important;
            display: flex !important;
            justify-content: flex-end !important;
          }

          /* Scoped Modal Form Styles */
          .po-form-label {
            font-size: 13px;
            font-weight: 700;
            color: #475569;
            margin-bottom: 8px;
            text-transform: uppercase;
            letter-spacing: 0.05em;
          }
          .po-radio-group {
            display: flex;
            gap: 12px;
            margin-bottom: 8px;
          }
          .po-radio-btn {
            position: absolute;
            opacity: 0;
            width: 0;
            height: 0;
          }
          .po-radio-label {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 8px 20px;
            font-size: 13.5px;
            font-weight: 600;
            color: #64748b;
            background-color: #ffffff;
            border: 1.5px solid #e2e8f0;
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.2s ease;
            user-select: none;
          }
          .po-radio-label:hover {
            border-color: #cbd5e1;
            color: #475569;
            background-color: #f8fafc;
          }
          .po-radio-btn:checked + .po-radio-label {
            border-color: #2563eb;
            color: #1d4ed8;
            background-color: #eff6ff;
            box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.1);
          }
          .po-select {
            width: 100%;
            height: 42px;
            padding: 0 14px;
            font-size: 13.5px;
            font-weight: 600;
            color: #1e293b;
            background-color: #ffffff;
            border: 1.5px solid #e2e8f0;
            border-radius: 8px;
            outline: none;
            transition: all 0.2s ease;
            appearance: none;
            background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
            background-repeat: no-repeat;
            background-position: right 14px center;
            background-size: 16px;
          }
          .po-select:focus {
            border-color: #2563eb;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
          }
          .po-textarea {
            width: 100%;
            padding: 12px 14px;
            font-size: 13.5px;
            font-weight: 500;
            color: #1e293b;
            background-color: #ffffff;
            border: 1.5px solid #e2e8f0;
            border-radius: 8px;
            outline: none;
            transition: all 0.2s ease;
            resize: vertical;
          }
          .po-textarea:focus {
            border-color: #2563eb;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
          }
          .po-card {
            background-color: #ffffff;
            border: 1px solid #e2e8f0;
            border-radius: 12px;
            padding: 24px;
            box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
            margin-bottom: 24px;
          }
          .po-preview-frame {
            background-color: #e2e8f0;
            border-radius: 12px;
            padding: 30px;
            max-height: 700px;
            overflow-y: auto;
            border: 1.5px solid #cbd5e1;
            box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.08);
          }
          .po-preview-paper {
            background-color: #ffffff;
            padding: 50px 40px;
            box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.15), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
            border-radius: 6px;
            margin: 0 auto;
            max-width: 800px;
            box-sizing: border-box;
          }

          /* Button Enhancements */
          .po-btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            padding: 8px 18px;
            font-size: 13px;
            font-weight: 600;
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
            outline: none;
            border: 1.5px solid transparent;
            min-height: 38px;
          }
          
          .po-btn:disabled {
            opacity: 0.6;
            cursor: not-allowed;
            transform: none !important;
            box-shadow: none !important;
          }
          
          .po-btn-close {
            background-color: #ffffff;
            border-color: #cbd5e1;
            color: #475569;
          }
          
          .po-btn-close:hover {
            background-color: #f8fafc;
            border-color: #94a3b8;
            color: #1e293b;
          }
          
          .po-btn-primary {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            color: #ffffff;
            box-shadow: 0 4px 10px rgba(37, 99, 235, 0.2);
          }
          
          .po-btn-primary:hover:not(:disabled) {
            background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
            transform: translateY(-1px);
            box-shadow: 0 6px 14px rgba(37, 99, 235, 0.3);
          }
          
          .po-btn-secondary {
            background: linear-gradient(135deg, #0f766e 0%, #0d9488 100%);
            color: #ffffff;
            box-shadow: 0 4px 10px rgba(15, 118, 110, 0.2);
          }
          
          .po-btn-secondary:hover:not(:disabled) {
            background: linear-gradient(135deg, #0d9488 0%, #0f766e 100%);
            transform: translateY(-1px);
            box-shadow: 0 6px 14px rgba(15, 118, 110, 0.3);
          }
          
          .po-btn-save {
            background: linear-gradient(135deg, #475569 0%, #334155 100%);
            color: #ffffff;
            box-shadow: 0 4px 10px rgba(71, 85, 105, 0.2);
          }
          
          .po-btn-save:hover:not(:disabled) {
            background: linear-gradient(135deg, #334155 0%, #1e293b 100%);
            transform: translateY(-1px);
            box-shadow: 0 6px 14px rgba(71, 85, 105, 0.3);
          }
        `}</style>

        <div className="po-card">
          <div className="row">
            <div className="col-md-6 mb-3 mb-md-0">
              <div className="po-form-label">Purchase Order Type</div>
              <div className="po-radio-group">
                <div>
                  <input
                    className="po-radio-btn"
                    type="radio"
                    name="poType"
                    id="poTypeNew"
                    onChange={() => setReceiverPoType("New")}
                    value="New"
                    checked={receiverPoType === "New"}
                  />
                  <label className="po-radio-label" htmlFor="poTypeNew">
                    New Order
                  </label>
                </div>
                <div>
                  <input
                    className="po-radio-btn"
                    type="radio"
                    name="poType"
                    id="poTypeRevised"
                    onChange={() => setReceiverPoType("Revised")}
                    value="Revised"
                    checked={receiverPoType === "Revised"}
                  />
                  <label className="po-radio-label" htmlFor="poTypeRevised">
                    Revised Order
                  </label>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <label htmlFor="poType" className="po-form-label">Purchase Order For</label>
              <select
                name="poType"
                id="poType"
                className="po-select"
                value={poType}
                onChange={({ currentTarget }) => setPoType(currentTarget.value)}
              >
                <option value="">Select Performer Type...</option>
                {allPoTypes.map((p) => (
                  <option key={p.value} value={p.value}>
                    {p.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {poAction === "upload" && (
          <div className="row">
            <div className="col-md-12">
              <UploadDocument
                documents={documents}
                onFileChange={onFileChange}
                handleFileRemove={handleFileRemove}
              ></UploadDocument>
            </div>
          </div>
        )}

        {poType !== "" && poAction !== "upload" && (
          <React.Fragment>
            <div className="po-card">
              <div className="po-form-label mb-3">Document Print Preview</div>
              <div className="po-preview-frame">
                <style>{cssStyles}</style>
                <div className="po-preview-paper">
                  <div className="po-document-shell">
                    <table className="po-document-accent">
                      <tbody>
                        <tr>
                          <td style={{ width: "34%", backgroundColor: "#0f766e" }}>&nbsp;</td>
                          <td style={{ width: "33%", backgroundColor: "#2563eb" }}>&nbsp;</td>
                          <td style={{ width: "33%", backgroundColor: "#f59e0b" }}>&nbsp;</td>
                        </tr>
                      </tbody>
                    </table>
                    <div style={{ textAlign: "center", padding: "18px 20px 16px 20px" }}>
                      <img
                        id="Img1"
                        src={`/assets/Img/logo.png`}
                        style={{
                          maxHeight: "55px",
                          width: "auto",
                          display: "block",
                          margin: "0 auto",
                        }}
                        alt="IPCS Logo"
                      />
                    </div>
                    <div id="printBody" ref={printBodyRef}>
                      <table className="po-header-table">
                        <tbody>
                          <tr>
                            <td className="po-header-text">
                              <p>600 Highway 169 South, METROPOINT, Suite 1595 Minneapolis, MN 55426</p>
                              <p>
                                Tel: 952-541-4888 | Fax: 952-541-1222 | Email: <a href="mailto:accounts@ipcs.net">accounts@ipcs.net</a>
                              </p>
                              <p>
                                Websites: <a href="https://www.ipcs.net" target="_blank" rel="noopener noreferrer">www.ipcs.net</a> | <a href="https://www.workfinity.com" target="_blank" rel="noopener noreferrer">www.workfinity.com</a>
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div style={{ height: "15px", lineHeight: "15px", fontSize: "1px" }}>&nbsp;</div>

                      <div className="po-title-block">
                        <table className="po-title-table">
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top", paddingRight: "24px" }}>
                                <div className="po-title-label">PROFESSIONAL SERVICES ENGAGEMENT</div>
                                <h1 className="po-main-title">
                                  {receiverPoType === "Revised" && <span style={{ color: "#dc2626" }}>REVISED </span>}
                                  PURCHASE ORDER
                                </h1>
                                <p className="po-subtitle-relation" style={{ margin: "8px 0 0 0" }}>
                                  This Purchase Order is issued pursuant to the Consulting Services Agreement signed by IPCS and the <span>{poType}</span>.
                                </p>
                              </td>
                              <td style={{ textAlign: "right", verticalAlign: "top", width: "42%" }}>
                                <table className="po-meta-card" style={{ width: "100%", borderCollapse: "collapse", padding: 0 }}>
                                  <tbody>
                                    <tr>
                                      <td className="po-meta-cell left" style={{ textAlign: "right" }}>
                                        <div className="po-meta-label">PURCHASE ORDER #</div>
                                        <div className="po-meta-value" style={{ fontSize: "17px", color: "#2563eb", fontWeight: "bold" }}>
                                          {poId}
                                        </div>
                                      </td>
                                      <td className="po-meta-cell" style={{ textAlign: "right" }}>
                                        <div className="po-meta-label">DATE ISSUED</div>
                                        <div className="po-meta-value" style={{ fontWeight: "bold" }}>
                                          {new Date().toLocaleDateString()}
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div style={{ height: "10px", lineHeight: "10px", fontSize: "1px" }}>&nbsp;</div>

                      <table className="po-parties-table">
                        <tbody>
                          <tr>
                            <td style={{ width: "48%", verticalAlign: "top", padding: 0 }}>
                              <table className="po-party-box">
                                <tbody>
                                  <tr>
                                    <td className="po-party-accent" style={{ backgroundColor: "#0f766e" }}>&nbsp;</td>
                                    <td className="po-party-content">
                                      <div className="po-party-label">ISSUED BY</div>
                                      <div className="po-party-name">International Projects Consultancy Services (IPCS) Inc.</div>
                                      <div className="po-party-address">
                                        600 Highway 169 South, METROPOINT, Suite 1595<br />
                                        Minneapolis, MN 55426
                                      </div>
                                      <div className="po-party-contact">
                                        Phone: 952-541-4888 | Email: <a href="mailto:accounts@ipcs.net">accounts@ipcs.net</a>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td style={{ width: "4%" }}>&nbsp;</td>
                            <td style={{ width: "48%", verticalAlign: "top", padding: 0 }}>
                              <table className="po-party-box">
                                <tbody>
                                  <tr>
                                    <td className="po-party-accent" style={{ backgroundColor: "#2563eb" }}>&nbsp;</td>
                                    <td className="po-party-content">
                                      <div className="po-party-label">ISSUED TO ({poType?.toUpperCase()})</div>
                                      <div className="po-party-name">{partnerName}</div>
                                      <div className="po-party-address">{partAddress || "Address details pending"}</div>
                                      <div className="po-party-contact">
                                        Phone: {formatPhoneNumber(partContact) || "Pending"}<br />
                                        Email: <a href={`mailto:${partEmail}`}>{partEmail || "Pending"}</a>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div style={{ height: "18px", lineHeight: "18px", fontSize: "1px" }}>&nbsp;</div>

                      <table style={{ width: "100%", borderCollapse: "collapse" }} className="po-section-title-container">
                        <tbody>
                          <tr>
                            <td className="po-section-heading-cell">
                              <h2 className="po-section-main-title">CANDIDATE ENGAGEMENT DETAILS</h2>
                              <p className="po-section-subtitle">
                                IPCS is engaging the following Candidate to work on IPCS's Project:
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div style={{ height: "12px", lineHeight: "12px", fontSize: "1px" }}>&nbsp;</div>

                      <table className="po-details-table">
                        <tbody>
                          <tr className="po-details-row">
                            <td className="po-details-label">Candidate Name</td>
                            <td className="po-details-value po-detail-strong">
                              {candidateObj.performername + " " + candidateObj.lastName}
                            </td>
                          </tr>
                          {poType === "subcontractor" && (
                            <tr className="po-details-row">
                              <td className="po-details-label">Last 4 digits of SSN</td>
                              <td className="po-details-value">{ssn}</td>
                            </tr>
                          )}
                          <tr className="po-details-row">
                            <td className="po-details-label">Agency / Client</td>
                            <td className="po-details-value">
                              State: {getFieldData(candidateObj.performerData, "projectengagement", "State")}, Agency: {getFieldData(candidateObj.performerData, "projectengagement", "AgencyName")}
                            </td>
                          </tr>
                          <tr className="po-details-row">
                            <td className="po-details-label">Responsibilities / Role</td>
                            <td className="po-details-value po-detail-strong">
                              {getFieldData(candidateObj.performerData, "projectengagement", "PositionTitle")}
                            </td>
                          </tr>
                          <tr className="po-details-row">
                            <td className="po-details-label">Project Location</td>
                            <td className="po-details-value">
                              {getFieldData(candidateObj.performerData, "projectengagement", "PositionLocation")}
                            </td>
                          </tr>
                          <tr className="po-details-row">
                            <td className="po-details-label">Duration</td>
                            <td className="po-details-value">
                              {candidateObj?.duration?.duration}+ Months, Extendible
                            </td>
                          </tr>
                          <tr className="po-details-row">
                            <td className="po-details-label">Start Date</td>
                            <td className="po-details-value">
                              TBD, After Background Check
                            </td>
                          </tr>
                          <tr className="po-details-row">
                            <td className="po-details-label">Rate Payable by IPCS</td>
                            <td className="po-details-value po-rate-value">
                              ${payRate ? payRate : "0.00"}/hr (all inclusive)
                            </td>
                          </tr>
                          {poType === "subcontractor" && (
                            <tr className="po-details-row">
                              <td className="po-details-label">Background Check</td>
                              <td className="po-details-value">
                                Background Check and Drug Screen to be completed. I-9, E-Verify to be provided.
                              </td>
                            </tr>
                          )}
                          <tr className="po-details-row">
                            <td className="po-details-label">Additional Terms &amp; Conditions</td>
                            <td className="po-details-value" style={{ fontStyle: otherNotes ? "normal" : "italic", color: otherNotes ? "#0f172a" : "#94a3b8" }}>
                              {otherNotes || "None"}
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div style={{ height: "18px", lineHeight: "18px", fontSize: "1px" }}>&nbsp;</div>

                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <tbody>
                          <tr>
                            <td className="po-terms-note">
                              All other Terms and Conditions as per the Consulting Services Agreement between IPCS and the {poType} will remain the same.
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div style={{ height: "20px", lineHeight: "20px", fontSize: "1px" }}>&nbsp;</div>

                      <table className="po-signatures-block">
                        <tbody>
                          <tr>
                            <td className="po-sig-column left" style={{ width: "48%", verticalAlign: "top" }}>
                              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <tbody>
                                  <tr>
                                    <td className="po-sig-company">
                                      International Projects Consultancy Services (IPCS) Inc.
                                    </td>
                                  </tr>
                                  {esignName && (
                                    <tr>
                                      <td style={{ paddingBottom: "10px" }}>
                                        <div className="po-esign-watermark">
                                          <span style={{ fontSize: "11px", display: "block", color: "#16a34a", marginBottom: "4px", fontWeight: "bold" }}>
                                            DIGITALLY SIGNED
                                          </span>
                                          Signer: {esignName}<br />
                                          IP: {ipAddress}<br />
                                          Date: {new Date().toUTCString()}
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                  <tr>
                                    <td style={{ height: esignName ? "15px" : "35px", lineHeight: esignName ? "15px" : "35px", fontSize: "1px" }}>&nbsp;</td>
                                  </tr>
                                  <tr>
                                    <td className="po-sig-placeholder">
                                      <div className="po-sig-label">Authorized Signature</div>
                                      <div className="po-sig-name">Kuldeep Dhar</div>
                                      <div className="po-sig-title">CEO</div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td style={{ width: "4%" }}>&nbsp;</td>
                            <td className="po-sig-column right" style={{ width: "48%", verticalAlign: "top" }}>
                              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <tbody>
                                  <tr>
                                    <td className="po-sig-company">
                                      {partnerName} ({poType})
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ height: esignName ? "80px" : "35px", lineHeight: esignName ? "80px" : "35px", fontSize: "1px" }}>&nbsp;</td>
                                  </tr>
                                  <tr>
                                    <td className="po-sig-placeholder">
                                      <div className="po-sig-label">Authorized Signature</div>
                                      <div className="po-sig-name">{keyName}</div>
                                      <div className="po-sig-title">{partTitle}</div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="po-card">
              <div className="row">
                <div className="col-md-12">
                  <label htmlFor="otherNotes" className="po-form-label">Additional Terms &amp; Conditions (if any)</label>
                  <textarea
                    cols="2"
                    rows={3}
                    id="otherNotes"
                    name="otherNotes"
                    className="po-textarea"
                    value={otherNotes}
                    placeholder="Enter any custom clauses, terms, or notes to append to the Purchase Order..."
                    onChange={({ currentTarget }) => setOtherNotes(currentTarget.value)}
                  ></textarea>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </Modal.Body>
      <Modal.Footer style={{ backgroundColor: "#f8fafc", borderTop: "1px solid #edf2f7" }}>
        <button className="po-btn po-btn-close" onClick={() => handleGenShowHide("")}>
          <i className="fa fa-times mr-1"></i> Close
        </button>

        {poAction === "generate" && (
          <button
            className="po-btn po-btn-primary"
            disabled={saveBtnProccess || poType === ""}
            onClick={doSubmit}
          >
            {saveBtnProccess ? (
              <i className="fa fa-circle-o-notch fa-spin mr-1"></i>
            ) : (
              <i className="fa fa-cog mr-1"></i>
            )}
            Save / Generate
          </button>
        )}
        {poAction !== "upload" && (
          <button
            className="po-btn po-btn-secondary"
            disabled={pdfBtnProccess || poType === ""}
            onClick={handlePrintPdf}
          >
            {pdfBtnProccess ? (
              <i className="fa fa-circle-o-notch fa-spin mr-1"></i>
            ) : (
              <i className="fa fa-print mr-1"></i>
            )}
            Print PDF
          </button>
        )}

        {poAction === "upload" && (
          <button
            className="po-btn po-btn-save"
            disabled={updBtnProccess || poType === "" || documents.length === 0}
            onClick={uploadPoOrder}
          >
            {updBtnProccess ? (
              <i className="fa fa-circle-o-notch fa-spin mr-1"></i>
            ) : (
              <i className="fa fa-save mr-1"></i>
            )}
            Save
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default PrintPurchaseOrder;
